/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiAttributeMapping } from './ApiAttributeMapping';
import {
    ApiAttributeMappingFromJSON,
    ApiAttributeMappingFromJSONTyped,
    ApiAttributeMappingToJSON,
    ApiAttributeMappingToJSONTyped,
} from './ApiAttributeMapping';

/**
 * 
 * @export
 * @interface ApiMappings
 */
export interface ApiMappings {
    /**
     * 
     * @type {{ [key: string]: ApiAttributeMapping; }}
     * @memberof ApiMappings
     */
    map: { [key: string]: ApiAttributeMapping; };
}

/**
 * Check if a given object implements the ApiMappings interface.
 */
export function instanceOfApiMappings(value: object): value is ApiMappings {
    if (!('map' in value) || value['map'] === undefined) return false;
    return true;
}

export function ApiMappingsFromJSON(json: any): ApiMappings {
    return ApiMappingsFromJSONTyped(json, false);
}

export function ApiMappingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiMappings {
    if (json == null) {
        return json;
    }
    return {
        
        'map': (mapValues(json['map'], ApiAttributeMappingFromJSON)),
    };
}

export function ApiMappingsToJSON(json: any): ApiMappings {
    return ApiMappingsToJSONTyped(json, false);
}

export function ApiMappingsToJSONTyped(value?: ApiMappings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'map': (mapValues(value['map'], ApiAttributeMappingToJSON)),
    };
}

